import { z } from 'zod';

const literalBoolean = z.union([z.literal('true'), z.literal('false')]).default('false');

export const processEnvSchema = z.object({
    API_BASE_URL: z.url().endsWith('/'),
    API_REALTIME_BASE_URL: z.url().endsWith('/'),
    APP_VERSION: z.string().default('dev'),
    DATADOG_PROXY_URL: z.url(),
    ENABLE_DATA_DOG: literalBoolean,
    MIXPANEL_API_HOST: z.url(),
    MUI_X_LICENSE_KEY: z.string().optional(),
    REFETCH_ONFOCUS: literalBoolean,
    TINY_MCE_LICENSE_KEY: z.string().length(48).optional(),
});

export const appEnvironmentSchema = processEnvSchema.transform((env) => ({
    apiBaseUrl: env.API_BASE_URL,
    apiRealtimeBaseUrl: env.API_REALTIME_BASE_URL,
    appVersion: env.APP_VERSION,
    datadogProxyUrl: env.DATADOG_PROXY_URL,
    enableDataDog: env.ENABLE_DATA_DOG === 'true',
    mixpanelApiHost: env.MIXPANEL_API_HOST,
    muiXLicenseKey: env.MUI_X_LICENSE_KEY,
    refetchOnFocus: env.REFETCH_ONFOCUS === 'true',
}));

export type AppEnvironment = z.infer<typeof appEnvironmentSchema>;
